export function addViewAllModulesLink() {
  if (document.querySelector('.sj-page-catalog-root')) {
    let popularAstroModules = document.querySelector('[data-course="separator-popular-astro-modules"]');
    let popularAirflowModules = document.querySelector('[data-course="separator-popular-airflow-modules"]');

    let viewAllAstroModules = document.createElement('a');
    viewAllAstroModules.innerText = "View All Modules";
    viewAllAstroModules.classList.add(...['.as-view-all-modules']);
    viewAllAstroModules.setAttribute('href', '/page/all-modules#product_astro');

    let popularAstroWrapper = document.createElement('div');
    popularAstroWrapper.classList.add('as-popular-modules-wrapper');
    popularAstroWrapper.innerHTML = `${popularAstroModules.outerHTML} ${viewAllAstroModules.outerHTML}`;
    popularAstroModules.replaceWith(popularAstroWrapper);


    let viewAllAirflowModules = document.createElement('a');
    viewAllAirflowModules.innerText = "View All Modules";
    viewAllAirflowModules.classList.add(...['.as-view-all-modules']);
    viewAllAirflowModules.setAttribute('href', '/page/all-modules#product_airflow');

    let popularAirflowWrapper = document.createElement('div');
    popularAirflowWrapper.classList.add('as-popular-modules-wrapper');
    popularAirflowWrapper.innerHTML = `${popularAirflowModules.outerHTML} ${viewAllAirflowModules.outerHTML}`;
    popularAirflowModules.replaceWith(popularAirflowWrapper);
  }
}